import { React, useState } from 'react';
import './App.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Message from 'antd-message';

const LeadgenFormModal = ({ modalShow, setModalShow }) => {
  const sendMail = (data) => {
    fetch('https://api.tyroo.com/contact-us', {
      method: 'POST',
      body: JSON.stringify(data)
    })
      .then((response) => {
        if (response.status == 200) {
          setModalShow(false);
          Message.success('biểu mẫu được gửi thành công !');
        } else {
          Message.error('Lỗi khi gửi biểu mẫu !');
        }
      })
      .catch((error) => console.error('Error!', error.message));
  };

  const submitForm = (e) => {
    e.preventDefault();
    sendMail({
      ...formData
    });
    setTimeout(() => {
      setFormData({
        name: '',
        email: ''
      });
    }, 2000);
  };
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });

  const { name, email } = formData;
  return (
    <>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: '0px', paddingBottom: '0px' }}
        ></Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          <h4 style={{ marginBottom: '20px' }}>Quảng cáo với Snapchat</h4>
          <Form onSubmit={submitForm}>
            <Form.Group className='mb-3' controlId='formBasicName'>
              {/* <Form.Label>Tên</Form.Label> */}
              <Form.Control
                type='name'
                placeholder='Nhập tên bạn'
                value={name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              {/* <Form.Label>Thư điện tử </Form.Label> */}
              <Form.Control
                type='email'
                placeholder='Nhập email của bạn'
                value={email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </Form.Group>

            <Button variant='primary' type='submit'>
              Gửi đi
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LeadgenFormModal;
